/**
 * Cross-portal navigation for the "Switch Platform" menu (components/SwitchPlatformMenu.vue).
 *
 * Each destination portal accepts a `?jwtToken=` URL param to skip its own login — mirrors
 * va-portal's own SwitchPlatformMenu (src/utils/navbar/switchPlatform.js), which this menu
 * is the counterpart of.
 */
import { getPortalBaseUrl } from "@/utils/portalUrl";

// Local-testing override, disabled. To point Switch Platform at locally-running sibling
// apps again, uncomment LOCAL_TESTING and the matching early return in each getter below.
// It is scoped to this file (rather than changing the shared getPortalBaseUrl()) so
// Wallet/Home/logout links elsewhere keep pointing at the real va-portal deployment while
// only Switch Platform is redirected.
// const LOCAL_TESTING = true;

function getVaPortalBaseUrl() {
  // if (LOCAL_TESTING) return "http://localhost:8080/lis/patientpage-staging";
  return getPortalBaseUrl();
}

function getUnimodBaseUrl() {
  // if (LOCAL_TESTING) return "http://localhost:5173";
  return process.env.VUE_APP_ENV === "production"
    ? "https://vibrant-wellness-portal.pages.dev"
    : "https://staging.vibrant-wellness-portal.pages.dev";
}

// The `vibrant-intelligence` key is this app's own id — it's the current platform here, so
// it's never navigated to. Its user-facing label is "Clinical Calendar" (VP-18687), the only page still in use.
//
// newTab: Unimod opens in a new tab; Provider Portal (Vibrant Portal) navigates in the
// same tab.
export const SWITCH_PLATFORM_OPTIONS = [
  { key: "vibrant-portal", label: "Vibrant Portal", newTab: false },
  { key: "unimod", label: "Unimod", newTab: true },
  { key: "vibrant-intelligence", label: "Clinical Calendar", newTab: false },
];

export function getSwitchPlatformUrl(key, token) {
  switch (key) {
    case "vibrant-portal":
      return `${getVaPortalBaseUrl()}/#/home?jwtToken=${token}`;
    case "unimod":
      return `${getUnimodBaseUrl()}/?jwtToken=${token}`;
    default:
      return null;
  }
}
